/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import type { ReactNode } from 'react';
import * as React from 'react';

import { Grid, PageGridContainer, Typography, Typography2 } from '@coursera/cds-core';

const style = {
  wrapper: () => css`
    padding-top: var(--cds-spacing-600);
    padding-bottom: var(--cds-spacing-400);
  `,
  certificates: () => css`
    width: 100%;
    display: flex;
    gap: 24px;
  `,
};

type Props = {
  title?: string | null;
  subtitle?: string | null;
  certificates?: ReactNode | null;
};

const RolePageConsumerCertificatesModule: React.FC<Props> = ({ title, subtitle, certificates }) => {
  if (!title || !certificates) return null;

  return (
    <PageGridContainer>
      <Grid container css={style.wrapper}>
        <section>
          <>
            <Typography variant="h1semibold" component="h2" style={{ marginBottom: '8px' }}>
              {title}
            </Typography>
            <Typography2 component="p" variant="bodyPrimary" color="supportText" style={{ marginBottom: '32px' }}>
              {subtitle}
            </Typography2>
          </>
        </section>
        <Grid css={style.certificates}>{certificates}</Grid>
      </Grid>
    </PageGridContainer>
  );
};

export default RolePageConsumerCertificatesModule;
